export { default, getServerSideProps } from './B2BOrgRecover';
